import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { useUser } from "../../../context/user-context";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { API } from "../../../constants/api";
import useAuthAxios from "../../../utils/baseAxios";
import { errorMessage } from "../../../utils/errorMessage";
import { darkNoTransaction, noTransaction } from "../../../assets/images";
import AddBanks from "./AddBanks";
import BankDetail from "./BankDetail";
import CryproAddresses from "./CryproAddresses";

const BankDetails = ({ setOpenBankDetails }: any) => {
  const [openAddBank, setOpenAddBank] = useState<boolean>(false);
  const [openBank, setOpenBank] = useState<boolean>(false);
  const { userDetails, theme } = useUser();
  const [bankId, setBankId] = useState<string>("");
  const banks = userDetails?.user?.banks;
  const axiosInstance = useAuthAxios();
  const [screen, setScreen] = useState<boolean>(true);
  const getAllBanks = async () => {
    const response = await axiosInstance.get(API.getBanks);
    return response.data;
  };

  const { data: allBanks, error: error1 } = useQuery({
    queryKey: ["all-banks"],
    queryFn: getAllBanks,
    retry: 1,
  });
  const getAllOldBanks = async () => {
    const response = await axiosInstance.get(API.getBanksDeex);
    return response.data;
  };

  const { data: allOldBanks, error: error2 } = useQuery({
    queryKey: ["all-old-banks"],
    queryFn: getAllOldBanks,
    retry: 1,
  });
  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1, error2]);
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-3 items-center">
          <button
            onClick={() => {
              setOpenBankDetails(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[18px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[16px]">
            Saved Accounts
          </h4>
        </div>
        <div className="w-full mt-6  rounded-lg py-4  flex justify-start items-center ">
          <button
            onClick={() => setScreen(true)}
            className={
              screen
                ? "w-1/2  text-white bg-secondary_button text-[12px] py-2 rounded-[6px] font-bold"
                : "w-1/2   text-gray-500   text-[12px] font-bold"
            }
          >
            Bank Accounts
          </button>
          <button
            onClick={() => setScreen(false)}
            className={
              !screen
                ? "w-1/2  text-white bg-secondary_button text-[12px] py-2 rounded-[6px] font-bold"
                : "w-1/2   text-gray-500   text-[12px] font-bold"
            }
          >
            Wallet Addresses
          </button>
        </div>
        {screen ? (
          <>
            <div
              className={
                banks.length >= 2
                  ? " w-full h-[400px] overflow-auto"
                  : "mt-2 w-full "
              }
            >
              <div className={"w-full  py-4  "}>
                {banks.length < 1 ? (
                  <div className="flex flex-col justify-center mt-16 lgss:mt-24 items-center">
                    {theme === "dark" ? (
                      <img src={darkNoTransaction} alt="" />
                    ) : (
                      <img src={noTransaction} alt="" />
                    )}
                    <h4 className="font-bold text-[#869AA9] pt-2">
                      No default bank added
                    </h4>
                    <p className=" text-[#869AA9] pt-2 text-[12px]">
                      Kindly add bank details
                    </p>
                  </div>
                ) : (
                  <div className="w-full grid grid-cols-1  gap-4">
                    {banks
                      .sort((a: any, b: any) => b.isDefault - a.isDefault)
                      .map((bank: any, index: any) => (
                        <div
                          key={index}
                          onClick={() => {
                            setBankId(bank._id);
                            setTimeout(() => {
                              setOpenBank(true);
                            }, 500);
                          }}
                          className={
                            bank.isDefault
                              ? "  px-2 py-10 bg-defaultBankBg cursor-pointer flex flex-col justify-center bg-cover rounded-lg items-center"
                              : "  px-2 py-10 bg-noDefaultBankBg cursor-pointer flex flex-col justify-center bg-cover rounded-lg items-center"
                          }
                        >
                          <div className="flex justify-between gap-3 items-center">
                            <h4 className="font-semibold text-[#0B75C2] text-[16px]">
                              {bank.accountName}
                            </h4>
                            {/* <input
                  type="radio"
                  name=""
                  className="w-[20px] h-[20px]"
                  id=""
                /> */}
                          </div>
                          <h5 className="text-[#010D16] text-[15px] font-bold pt-2">
                            {bank.accountNumber}
                          </h5>
                          {(() => {
                            const matchedBank =
                              allBanks?.data.find(
                                (allBank: any) =>
                                  allBank.bankCode === bank.bankCode
                              ) ||
                              allOldBanks?.data.find(
                                (newBank: any) => newBank.code === bank.bankCode
                              );

                            return matchedBank ? (
                              <h5 className="text-[#010D16] font-medium text-[13px] pt-2">
                                {matchedBank.bankName ||
                                  matchedBank.name ||
                                  "Unknown Bank"}
                              </h5>
                            ) : null;
                          })()}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
            <h4 className=" text-center text-gray-500 dark:text-gray-400 text-[14px] font-medium">
              This is your withdrawal bank account and can be useful for easy
              funding of cash wallet
            </h4>
            <button
              onClick={() => setOpenAddBank(true)}
              className="mt-8 bg-secondary_button text-white font-medium text-[14px] h-[48px] rounded-xl w-full"
            >
              Add bank
            </button>
          </>
        ) : (
          <CryproAddresses />
        )}
      </div>
      {openAddBank && <AddBanks setOpenAddBank={setOpenAddBank} />}
      {openBank && <BankDetail setOpenBank={setOpenBank} bankId={bankId} />}
    </div>
  );
};

export default BankDetails;
